import {
  type CountryCode,
  CountryCodeEnum,
} from 'features/charity-vetting/types/charityVettingTypes';

const isCountryCode = (value: string | null): value is CountryCode =>
  value !== null && value in CountryCodeEnum;

export const parseCountryParam = (search: string): CountryCode | null => {
  const value = new URLSearchParams(search).get('country');
  return isCountryCode(value) ? value : null;
};
